import type { FeatureFlagRepository } from '#/domain/featureFlag/FeatureFlagRepository'

export class ToggleFeatureFlagUseCase {
  constructor(private readonly repository: FeatureFlagRepository) {}

  async execute(flagName: string, productName: string, enabled: boolean): Promise<void> {
    return this.repository.toggle(flagName, productName, enabled)
  }
}
